import React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom'
import Header from '../Header';

import { ReactSVG } from 'react-svg';
import { motion, AnimatePresence } from "framer-motion";
import { fadeInTransition } from './../../data/Transitions';
import { TechnologyPlanGameData } from './../../data/GameData';

import AddPeople from './AddPeople';
import AddRule from './AddRule';
import Summary from './Summary';
import Prompt from './Prompt';

class TechnologyPlan extends React.Component {
  
  constructor(props) {
    super(props)
    
    var self = this,
        rules = TechnologyPlanGameData.rules,
        params = new URLSearchParams(this.props.location.search),
        rulesData = (params.get('rules')) ? params.get('rules').split(';') : [];
    
    rulesData.forEach(item => {
      var itemData = item.split(',');
      
      if(itemData.length >= 6) {

        rules.push({
          person: itemData[0],
          colour: itemData[1],
          verb: itemData[2],
          device: itemData[3],
          place: itemData[4],
          time: itemData[5],
        })

      }
      
    })

    this.state = {
      isChangingRoutes: false,
      isShowingPrompt: false,
      timeOptions: TechnologyPlanGameData.timeOptions,
      people: TechnologyPlanGameData.people,
      rules: rules,
      printing: false
      //showSummaryByDefault: false, //(rules.length > 0),
    };
    
    if(rules.length > 0) {
      setTimeout(function() {
          self.props.history.push('/technology-plan/summary')
      }, 1000);
    }
    
  }
  
  componentDidMount() {
    
//     var path = this.props.location.pathname.split("/").pop();

    if(!this.state.people.length || !this.state.rules.length) {
      this.props.history.push('/technology-plan')
    }

  }
  
  didSelectBrandLogo = () => {
    var self = this;
    self.setState({isChangingRoutes: true})
     
    setTimeout(function() {
      //self.setState({isChangingRoutes: false})
      //self.props.history.push('https://playingitsafe.org.au/')
      window.location.href = 'https://playingitsafe.org.au/';
    }, 500);
  }
  
  didSelectBack = () => {
    var self = this;
    self.setState({isChangingRoutes: true})
     
    setTimeout(function() {
      self.setState({isChangingRoutes: false});
      self.props.history.goBack();
    }, 1000);
  }
  
  didSelectFinishAddingNames = () => {
    var self = this;
    
    if(!this.state.people.length) {
      return;
    }
    
    self.setState({isShowingPrompt: true})
  }
  
  didSelectGoToAddRules = () => {
    var self = this;
        
    self.setState({isChangingRoutes: true, isShowingPrompt: false})
    
    setTimeout(function() {
      self.props.history.push('/technology-plan/add-rule')
      self.setState({isChangingRoutes: false})
    }, 500);
  }

  didSelectAddNewRule = () => {
    var self = this;
        
    self.setState({isChangingRoutes: true})
    
    setTimeout(function() {
      self.props.history.push('/technology-plan/add-rule')
      self.setState({isChangingRoutes: false})
    }, 500);
  }
  
  didSelectPrint = () => {
    // @todo print screen...
    //prompt("Permalink", this.permalink());
    this.setState({printing:true});
    fetch('https://o18jzj3fw8.execute-api.ap-southeast-2.amazonaws.com/Prod/snap', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: this.permalink(),//'http://games.playingitsafe.org.au/share-that-photo?people=3%2C5%2C7%2C8',
        pdf: true,
        landscape: false,
        scale: "0.8"
      }),
    }).then((response) => response.json())
    .then((responseJson) => {
      this.setState({printing:false});
      console.log(responseJson);
      if(responseJson.url){
        //window.location.href = responseJson.url;
        const win = window.open(responseJson.url, '_blank');
        if (win != null) {
          win.focus();
        }
      }
    })
    .catch((error) => {
      this.setState({printing:false});
      console.error(error);
    });;
  }
  
  didSelectFinishRule = (rule) => {
    var self = this;
        
    self.setState({isChangingRoutes: true})
    
    setTimeout(function() {
      if(rule.person.length) {
        self.state.rules.push(rule);
      }
      self.props.history.push('/technology-plan/summary')
      self.setState({isChangingRoutes: false})
    }, 500);
  }
  
  didSelectSaveThenAddRule = (rule) => {
    var self = this;
    
    self.setState({isChangingRoutes: true})
    
    setTimeout(function() {
      if(rule.person.length) {
        self.state.rules.push(rule);
      }
      self.props.history.push('/technology-plan/add-rule')
      self.setState({isChangingRoutes: false})
    }, 500);
  }
  
  didSelectFinish = () => {
    var self = this;
    self.setState({isChangingRoutes: true, isShowingModal: false})
     
    setTimeout(function() {
      self.props.history.push('/')
      self.setState({isChangingRoutes: false})
    }, 1000);
  }
  
  encodeQueryData(data) {
     const ret = [];
     for (let d in data)
       ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
     return ret.join('&');
  }
  
  permalink() {
    var data = [];
        
    this.state.rules.forEach(rule => {
      
      data.push([
        rule.person,
        rule.colour,
        rule.verb,
        rule.device,
        rule.place,
        rule.time,
      ].join(','));
    })
        
    return document.location.href+'/?'+this.encodeQueryData({'rules':data.join(';')});
  }
  
  render() {
    
    const { isChangingRoutes, people, rules, isShowingPrompt, printing } = this.state;

    var self = this,
        mainClass = 'main--'+this.props.location.pathname.split("/").pop();

    return (
      
      <div>
          
          <Header onSelectBack={self.didSelectBack} onSelectBrandLogo={self.didSelectBrandLogo} />
  
          <motion.main id="main" className={mainClass} initial="unmounted" animate={(isChangingRoutes) ? 'unmounted' : 'mounted'} variants={fadeInTransition}>
  
            <Switch>
              
              <Route 
                exact 
                path="/technology-plan" 
                render={() => (
                  <AddPeople onFinish={self.didSelectFinishAddingNames} people={people}  />
                )
              } />
              
              <Route 
                exact 
                path="/technology-plan/add-rule" 
                render={() => (
                  <AddRule number={rules.length+1} onFinish={self.didSelectFinishRule} onAdd={self.didSelectSaveThenAddRule} people={people} rules={rules}  />
                )
              } />
              
              <Route 
                exact 
                path="/technology-plan/summary" 
                render={() => (
                  <Summary onAddNewRule={self.didSelectAddNewRule} onPrint={self.didSelectPrint} people={people} rules={rules} printingStatus={printing} />
                )
              } />
              
            </Switch>
            
            <div className="tech-plan-detail">
              <div className="pyramid"></div>
              
              <div className="dashed-circle">
                <ReactSVG src={require('../../images/dashed-circle.svg')} />
              </div>
              
              <div className="striped-circle">
                <ReactSVG src={require('../../images/striped-circle.svg')} />
              </div>
              
            </div>
            
          </motion.main>
          
          <AnimatePresence>
            {isShowingPrompt && (
              <Prompt onSelectFinish={self.didSelectGoToAddRules} />
            )}
          </AnimatePresence>

      </div>
      
    )
  }
};


export default withRouter(TechnologyPlan);
